    <template>
    <div class="map-wrap">
      <a href="https://www.maptiler.com" class="watermark"><img
          src="https://api.maptiler.com/resources/logo.svg" alt="MapTiler logo"/></a>
      <div class="map" ref="mapContainer"></div>


      <div id="legend" class="overlay" style="visibility: hidden">
        <h4 id="legend_header">legend</h4>
        <div>
          <span style="background-color: #FFEDA0"></span>
          <span style="background-color: #FED976"></span>
          <span style="background-color: #FEB24C"></span>
          <span style="background-color: #FD8D3C"></span>
          <span style="background-color: #FC4E2A"></span>
          <span style="background-color: #E31A1C"></span>
          <span style="background-color: #BD0026"></span>
          <span style="background-color: #800026"></span>
        </div>
        <div class="labels">
          <label>0</label>
          <label>10</label>
          <label>20</label>
          <label>30</label>
          <label>50</label>
          <label>70</label>
          <label>80</label>
          <label>100</label>
        </div>
      </div>
    </div>


    </template>

<script setup>

  import 'maplibre-gl/dist/maplibre-gl.css';
  import { Map, NavigationControl } from 'maplibre-gl';
  import * as maptilersdk from '@maptiler/sdk';
  import { onMounted, defineProps, shallowRef, markRaw, onUnmounted, watch, ref, defineEmits} from 'vue';

  const props = defineProps({
        apiKey: {
          type: String,
          required: true,
        },
        styleUrl: {
          type: String,
          required: true,
        },
        center: {
          type: Array,
          default: () => [0, 0],
        },
        zoom: {
          type: Number,
          default: 2,
        },
        features:{
          type: Object,
          required: true
        },
        features_color_legend:{
          type: Object,
          required: false
        }
      });


  const mapContainer = shallowRef(null);
  const map = shallowRef(null);
  const map_features = ref(null);
  //const current_indicator = ref('Domestic supply')
  const clicked_subasin = ref(''); 

  const emit = defineEmits(['emitSubasinName']);


  onMounted(() => {

    map.value = markRaw(new Map({
          container: mapContainer.value,
          style: `https://api.maptiler.com/maps/streets-v2/style.json?key=${props.apiKey}`,
          center: props.center,
          zoom: props.zoom,
    }));
    map.value.addControl(new NavigationControl({}), 'bottom-right');


    map.value.on('click', 'indicator_id', function (e) {
      var clicked_feature = e.features[0];
      new maptilersdk.Popup()
        .setLngLat(e.lngLat)
        .setHTML(`
                <div class="Marker">
                    <div  class="markerTop">
                      <h3><b>${e.features[0].properties.sub_basin}</b></br>
                    </div>
                    <div class="markerBottom rounded-lg bg-blue-500 text-blue p-4">
                      <ul class="popUpul">
                        <li><b>Indicator:</b> ${e.features[0].properties.Indicator}</li>
                        <li><b>Value:</b> ${e.features[0].properties.value}</li>
                        <li><b>Threshold:</b> ${e.features[0].properties.Threshold}</li>
                      </ul>
                    </div>
                  
                <div>`
            )
        .addTo(map.value);

        clicked_subasin.value = {
          'basin_id': clicked_feature.properties.basin_id,
          'subasin': clicked_feature.properties.sub_basin,
          'scenario_id': clicked_feature.properties.scenario_id,
          'indicator_name': clicked_feature.properties.Indicator,
          'indicator_id': clicked_feature.properties.indicator_id,
          'subasin_id': clicked_feature.properties.sub_basin_id
        }

    });

    // //hover pop up
    const hover_popup = new maptilersdk.Popup({
        closeButton: true,
        closeOnClick: true
    });


    map.value.on('mouseenter', 'indicator_id', function () {
        // Change the cursor style as a UI indicator.
        map.value.getCanvas().style.cursor = 'pointer';
    });

    map.value.on('mouseleave', 'indicator_id', function () {
        map.value.getCanvas().style.cursor = '';
        hover_popup.remove();
    });

    return {
        mapContainer,
    };
  });



  onUnmounted(() => {
    map.value?.remove();
  });


  watch(() => props.features, (newVal) => {

    //https://docs.maptiler.com/sdk-js/examples/choropleth-geojson/
  

    if (newVal['features'].length>0){
      //console.log('There are features')
      map_features.value = newVal;

      var geo_json = JSON.parse(JSON.stringify(newVal));


      //remove first the laeyer and then the source or it won't work
      if (map.value.getLayer('indicator_id')) {
        map.value.removeLayer('indicator_id');
      }

      if(map.value.getSource('indicator')){
        map.value.removeSource('indicator');
      }

      map.value.zoom = props.zoom;
      map.value.center = props.center;

      map.value.flyTo({
            center: props.center,
            zoom: props.zoom,
            speed: 0.7
        });

      map.value.addSource('indicator', {
          'type': 'geojson',
          'data': geo_json
        });

      const layers = map.value.getStyle().layers;
      const firstSymbolId = layers.find(layer => layer.type === 'symbol').id;

      var layer = null
      if(props.features_color_legend != null){
        //layer = {...props.features_color_legend.value}
        layer = JSON.parse(JSON.stringify(props.features_color_legend));

        //create color-legend for the layer
        var indicator_label = newVal.features[0].properties.Indicator;
        var fill_color = layer.paint['fill-color']
        var min_value = fill_color[3]
        var min_color = fill_color[4]
        var mid_value = fill_color[5]
        var mid_color = fill_color[6]
        var max_value = fill_color[7]
        var max_color = fill_color[8]

        var legendData = {}
        legendData['colors'] = [min_color, mid_color, mid_color, max_color, max_color];
        legendData['labels'] = [0, Math.ceil(min_value), Math.ceil(mid_value), Math.ceil(max_value), 100];
        updateLegend(legendData, indicator_label);



      }
      else{
        layer = {
          'id': 'indicator_id',
          'source': 'indicator',
          'type': 'fill',
          'paint': {
              'fill-color': [
                      'interpolate',
                      ['linear'],
                      ['get', 'value'],
                      20, "#3fd10a",
                      30, "#a3d10a",
                      50, "#d1ca0a",
                      60, "#dba512",
                      70, "#db6212",
                      80, "#db1212"
                ],
              'fill-opacity': 1,
              'fill-outline-color': '#000'
          }
        }
      }
      map.value.addLayer(
        layer,
        firstSymbolId
      );
    }  

  }, { deep: true });

    watch(() => clicked_subasin, (newVal) => {

      if (newVal != clicked_subasin.value){
        emitSubasinName(newVal)
        //clicked_subasin.value = newVal;
      }

  }, { deep: true });


  const emitSubasinName = (clicked_subasin) => {

      emit('emitSubasinName', clicked_subasin.value);
      console.log(clicked_subasin)
    };


  function updateLegend(legendData, indicator_label) {
    // Get the containers for the colors and labels
    const colorContainer = document.querySelector('#legend div:nth-of-type(1)');
    const labelContainer = document.querySelector('#legend .labels');

    // Clear existing content
    colorContainer.innerHTML = '';
    labelContainer.innerHTML = '';

    // Loop through the data to create new spans and labels
    legendData.colors.forEach(color => {
      const span = document.createElement('span');
      span.style.backgroundColor = color;
      colorContainer.appendChild(span);
    });

    legendData.labels.forEach(label => {
      const newLabel = document.createElement('label');
      newLabel.textContent = label;
      labelContainer.appendChild(newLabel);
    });

    document.getElementById('legend_header').innerHTML = indicator_label;
    document.getElementById('legend').style.visibility= 'visible' ;
  }






</script>



<style scoped>
@import "~maplibre-gl/dist/maplibre-gl.css";
@import "@/assets/style/map_style.css";

.map-wrap {
  width: 100%;
  height: calc(100vh - 77px); /* calculate height of the screen minus the heading */
}

.map {
  position: absolute;
  width: 100%;
  height: 90%;
}

.watermark {
  position: absolute;
  left: 10px;
  bottom: 90px;
  z-index: 999;
}


.markerBody {
  background: #e6e6e6;
  top: 0;
  border-radius: 2px;
  /* padding: 3px;  */
}


</style>